// extracted by mini-css-extract-plugin
module.exports = {"allRubricButton":"rubrics-menu_allRubricButton___FoRZ","wrapperRubrics":"rubrics-menu_wrapperRubrics__DfDGZ"};